<template>

  <div class="navbar" :class="{ 'narcolor': ([100,99, 98,97,96].includes($store.getters.userType)) }">
    <div class="left-logo">
      <span class="logo-text company-name">北京唯科致远科技有限公司</span>
      <div v-for="(item, index) in topNav" :key="index" class="nav-item-wrapper">
        <span
          v-if="item.type.includes($store.getters.userType)"
          class="logo-text nav-item"
          :class="{ 'active': $route.path === item.path }"
          @click="$router.push({ path: item.path })"
        >{{ item.name }}</span>
      </div>
      
      
    </div>
    
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="$store.getters.avatar" class="user-avatar">
          <span class="userName">{{ $store.getters.userName || "-" }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="$emit('resetPass',true)">
            <span style="display:block;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="$store.getters.userType === 6 && !$store.getters.lizhi" divided @click.native="$emit('inductionApply',true)">
            <span style="display:block;">申请入职</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="$store.getters.userType === 6 && $store.getters.lizhi" divided @click.native="lizhi()">
            <span style="display:block;">离职</span>
          </el-dropdown-item>
          <!-- leaveOffice -->
          <el-dropdown-item v-if="$store.getters.userType === 0 || $store.getters.typereport === 1" @click.native="report()">
            <span style="display:block;">查看报表</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="$store.getters.userType === 100" @click.native="invoice()">
            <span style="display:block;">发货单管理</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MessageBox } from 'element-ui'
import { driverQuite } from '@/api/driver.js' // 离职
import { logout } from '@/api/user.js'
import { notifyWrap } from "@/views/home/components/notify.js"

export default {
  data () {
    return {
      topNav:[
        {
          name:'首页',
          path:'/home/index',
          type: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20]
        },
        {
          name:'设备管理',
          path:'/equipment/index',
          type: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20]
        },
        {
          name:'作业管理',
          path:'/work/index',
          type: [0, 1, 2, 3, 5, 6, 8, 16,20]
        },
        {
          name:'RTK基站管理',
          path:'/rtkbase/index',
          type: [0,2,20]
        },
        {
          name:'任务管理',
          path:'/task/index',
          type: [0,]
        },
        {
          name:'账号管理',
          path:'/users/index',
          type: [0, ]
        },
        {
          name:'日志管理',
          path:'/flightLog/index',
          type: [0,3, 5, 6,]
        },
        {
          name:'RTK管理',
          path:'/rtk/index',
          type: [0]
        },
        {
          name:'厂商管理',
          path:'/manu/index',
          type: [0, 18]
        },
        {
          name:'在线设备',
          path:'/device/index',
          type: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16, 20]
        },
        {
          name:'轨迹回放',
          path:'/flightReplay/index',
          type: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16, 20]
        }

      ]
    }
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch("app/toggleSideBar");
    },
    // 退出
    async logout () {
      if(([100, 99, 98,97,96].includes(this.$store.getters.userType))){
        notifyWrap.remove()
        await logout();
        await this.$store.dispatch("user/logout");
        this.$router.push(`/login/bom`);
        return;
      }
      // 消除首页任务弹窗notify
      notifyWrap.remove()
      await logout();
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login`);
    },
    report(){
      this.$router.push({path:'/reports'})
    },
    invoice(){
      this.$router.push({path:'/invoice'})
    },
    modifyPassword () {

    },
    lizhi () {
      MessageBox.confirm(`确定离职`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          driverQuite({
          }).then(_ => {
            this.$msg.success('操作成功')
          })
        }).catch(err => {
          console.log(err);
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 40px;
  overflow: hidden;
  position: relative;
  background: rgba($color: #fff, $alpha: 0.2);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  .hamburger-container {
    line-height: 40px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .left-logo {
    line-height: 40px;
    display: flex;
    align-items: center;

    .logo-text {
      color: #fff;
      font-size: 14px;
      margin-left: 15px;
    }

    .company-name {
      margin-right: 40px;
      font-weight: 500;
    }

    .nav-item-wrapper {
      display: inline-block;

      .nav-item {
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 4px;
        transition: all 0.3s ease;
        position: relative;

        &:hover {
          background-color: rgba(255, 255, 255, 0.15);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        &.active {
          background-color: rgba(255, 255, 255, 0.25);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          font-weight: 500;

          &::after {
            content: '';
            position: absolute;
            bottom: -6px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 2px;
            background-color: #fff;
            border-radius: 1px;
          }
        }
      }
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 40px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 12px;
        padding: 0 10px;
        border-radius: 4px;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          background-color: rgba(255, 255, 255, 0.15);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        &.active-route {
          background-color: rgba(255, 255, 255, 0.2);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }

        .user-avatar {
          cursor: pointer;
          width: 28px;
          height: 28px;
          border-radius: 100%;
          border: 2px solid rgba(255, 255, 255, 0.3);
          transition: border-color 0.3s ease;
        }

        &:hover .user-avatar {
          border-color: rgba(255, 255, 255, 0.6);
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
        .userName {
          color: #fff;
          margin: 0 10px;
          transition: color 0.3s ease;
        }
        .userAccount {
          color: #999;
        }
      }
    }
  }
  position: fixed;
  top: 0;
  width: 100%;
  //background: linear-gradient(to bottom, 
                            //#2cc1f3ff 0%, 
                            //#85c4f1ff 50%,
                            //#89d4f4ff 100%);
  background: linear-gradient(to bottom,
      rgb(34, 100, 231) 0%,
      rgb(48, 94, 244) 50%,
      rgb(93, 127, 215) 100%);
  z-index: 1000;
}
.narcolor{
  background: #5a5e66;
}

// 移动端导航横向滚动
@media screen and (max-width: 768px) {
  .left-logo {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    .company-name {
      display: none;
    }

    .nav-item-wrapper {
      flex-shrink: 0;

      .nav-item {
        white-space: nowrap;
        flex-shrink: 0;
      }
    }
  }

  .right-menu .avatar-container {
    margin-right: 12px;

    .userName {
      display: none;
    }
  }
}

</style>
